import { useEffect, useState } from 'react';
import './App.css';
import Menu from './Components/Menu';
import Home from './Sections/Home';
import Partners from './Sections/Partners';
import Insta from './Sections/Insta';
import './Styles/animations.css'
import './Styles/backgrounds.css'
import Tiktok from './Sections/Tiktok';
import Awards from './Sections/Awards';
import Spotify from './Sections/Spotify';
import Products from './Sections/Products';
import FooterComponent from './Components/FooterComponent';
import MenuMobile from './Components/MenuMobile';



function App() {
  // menu
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

// animations
  useEffect(() => {
    const addSlideInAnimation = (selector, animationType) => {
      const elements = document.querySelectorAll(selector);
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (!entry.target.classList.contains('animated')) {
              entry.target.style.animationName = 'none';
              entry.target.style.animationName = animationType;
              entry.target.style.opacity = '1';
              entry.target.classList.add('animated');
            }
          } else {
            entry.target.classList.remove('animated');
            entry.target.style.opacity = '0';
            entry.target.style.animationName = 'none';
          }
        });
      }, {
        threshold: 0.1 
      });

      elements.forEach(element => {
        observer.observe(element);
      });

      return () => {
        elements.forEach(element => observer.unobserve(element));
      };
    };
    addSlideInAnimation('.fade-right', 'slideRight');
    addSlideInAnimation('.fade-left', 'slideLeft');
    addSlideInAnimation('.fade-up', 'slideUp');
    addSlideInAnimation('.fade-down', 'slideDown');
  }, []);

  return (
    <div className="App">
      <header id="navbar" className={`flex-center ${scrolled ? 'show' : 'hide'}`}>
        <Menu/>
      </header>
      <MenuMobile/>
      <Home/>
      <Partners/>
      <Insta/>
      <Tiktok/>
      <Awards/>
      <Spotify/>
      <Products/>
      <FooterComponent/>
    </div>
  );
}
export default App;
